import { Component, inject, signal } from '@angular/core';
import { take } from 'rxjs';
import { CheckoutService } from '../../services/checkout.service';
import { PaywallService } from '../../services/paywall.service';

const amountFormat = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Test mode stand-in for the Stripe checkout page. Paying continues exactly like a return from Stripe to #success,
 * cancelling like a return to #cancel.
 */
@Component({
  selector: 'yon-pw-paywall-simulate-payment',
  templateUrl: './paywall-simulate-payment.component.html',
  styleUrl: './paywall-simulate-payment.component.scss'
})
export class PaywallSimulatePaymentComponent {
  public paywallService = inject(PaywallService);
  private readonly checkoutService = inject(CheckoutService);

  readonly cancelling = signal(false);
  readonly error = signal('');

  readonly payment = this.paywallService.simulatedPayment;

  format(amount: number): string {
    return `${amountFormat.format(amount)} ${this.payment()?.currencyCode ?? ''}`;
  }

  simulatePayment(): void {
    // The success page completes the purchase, as it does when Stripe redirects back.
    this.paywallService.step.set('success');
  }

  cancelPayment(): void {
    this.cancelling.set(true);
    this.error.set('');
    this.checkoutService.cancelPurchaseSubscription().pipe(take(1)).subscribe({
      next: () => {
        localStorage.removeItem('sessionId');
        this.paywallService.simulatedPayment.set(undefined);
        this.paywallService.step.set('cards');
      },
      error: (error: unknown) => {
        console.error('Could not cancel the checkout:', error);
        this.error.set('The payment could not be cancelled. Please try again.');
        this.cancelling.set(false);
      }
    });
  }
}
